import { render } from "./HzbaList.vue?vue&type=template&id=0a9aacc8&scoped=true&ts=true"
import script from "./HzbaList.vue?vue&type=script&lang=ts"
export * from "./HzbaList.vue?vue&type=script&lang=ts"

import "./HzbaList.vue?vue&type=style&index=0&id=0a9aacc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9aacc8"]])

export default __exports__